const timezoneMoment = require('moment-timezone/builds/moment-timezone-with-data-10-year-range.min.js');

import { Moment as MomentObject } from 'moment-timezone';

export const moment = timezoneMoment;

export type Moment = (
  arg1?: string | Date | number | MomentObject,
  format?: string,
  arg3?: string | boolean,
  arg4?: boolean,
) => MomentObject;

/**
 * Load https://momentjs.com/ with timezone & locale
 */
export const MomentProvider = {
  provide: 'moment',
  useValue: timezoneMoment,
};
